import PaymentContainer from './PaymentContainer';

export default PaymentContainer;
